module.exports = __webpack_public_path__ + "static/media/icon_account.dfe3300b.svg";